export default {
    APPS: [
        {
            sku: 'chat',
            link: 'chat'
        },
        {
            sku: 'discounts',
            link: 'discounts.list'
        },
        {
            sku: 'facebookPixel',
            link: 'facebookPixel'
        },
        {
            sku: 'fulfillers',
            link: 'fulfillers.list'
        },
        {
            sku: 'fullstory',
            link: 'fullstory'
        },
        {
            sku: 'googleAnalytics',
            link: 'googleAnalytics'
        },
        {
            sku: 'mailchimp',
            link: 'mailchimp'
        },
        {
            sku: 'pinterest',
            link: 'pinterest'
        },
        {
            sku: 'postage',
            link: 'postage.edit'
        },
        {
            sku: 'privy',
            link: 'privy'
        },
        {
            sku: 'shipping',
            link: 'postage.edit'
        },
        {
            sku: 'yotpo',
            link: 'yotpo'
        },
        {
            sku: 'zapier',
            link: 'zapier'
        },
        {
            sku: 'avalara',
            link: 'avalara'
        }
    ]
};



// WEBPACK FOOTER //
// ./src/app/pages/appStore2/components/appCardConstants.js